/**
 * Convert cents to dollars
 */

import Cents from 'goodeggs-money';

export default angular
  .module('filters.toDollars', [])

  .filter(
    'toDollars',
    () =>
      function(cents) {
        if (cents == null) {
          cents = 0;
        }
        return new Cents(Cents.round(cents)).toString();
      },
  );
